<template>
  <!-- 在最外層容器添加一個固定高度的 div -->
  <div 
    class="scrollable-song-container" 
    ref="scrollContainer" 
    @scroll="handleScroll"
    :class="{ 'mobile-container': isMobile }"
  >
    <div class="container">
      <!-- 搜索輸入框 -->
      <div class="search-container">
        <textarea 
          v-model="searchQuery" 
          @input="onInputChange"
          @keydown.enter.prevent="handleSearchEnter"
          placeholder="你想知道什麼新鮮事，或是哪一首歌，告訴我不要客氣！" 
          style="color: white !important; margin-top: 10px !important; background-color: transparent !important;"
          class="form-control my-3 auto-resize-textarea"
          rows="1"
          ref="searchTextarea"
        ></textarea>
      </div>
      
      <!-- AI 控制區域 - 暫時註釋掉 -->
      <!-- <div class="ai-controls mb-3 ai-controls-container">
        <div class="d-none d-md-flex row w-100">
          <div class="col-md-6">
            <div class="model-select-container">
              <label for="model-select-desktop">
                <i class="fas fa-robot model-icon"></i>
              </label>
              <select id="model-select-desktop" v-model="selectedModel" class="form-select">
                <optgroup label="Deepseek 模型">
                  <option value="deepseek-chat">Deepseek-Chat</option>
                  <option value="deepseek-coder">Deepseek-Coder</option>
                </optgroup>
                <optgroup label="OpenAI 模型">
                  <option value="gpt-4o-mini">GPT-4o-mini</option>
                  <option value="gpt-3.5-turbo">GPT-3.5-turbo</option>
                  <option value="gpt-4o">GPT-4o</option>
                </optgroup>
                <optgroup label="其他模型">
                  <option value="gemini-1.5-pro">Gemini 1.5 Pro</option>
                  <option value="gemini-1.5-flash">Gemini 1.5 Flash</option>
                </optgroup>
              </select>
            </div>
          </div>
          <div class="col-md-6">
            <div class="action-buttons d-flex justify-content-end">
              <button class="btn btn-outline-secondary btn-xs" title="附加文件">
                <i class="fas fa-paperclip"></i>
              </button>
              <button 
                class="btn btn-xs" 
                :class="{ 
                  'btn-primary voice-active': isPlaying, 
                  'btn-outline-secondary': !isPlaying 
                }"
                @click="toggleVoicePlayback" 
                title="語音輸出"
              >
                <i class="fas" :class="{ 'fa-stop': isPlaying, 'fa-volume-up': !isPlaying }"></i>
              </button>
              <button class="btn btn-primary btn-xs" @click="handleSearchEnter" title="發送">
                <i class="fas fa-paper-plane"></i>
              </button>
            </div>
          </div>
        </div>
        
        <div class="d-flex d-md-none mobile-controls">
          <div class="mobile-select-container">
            <label for="model-select-mobile">
              <i class="fas fa-robot model-icon"></i>
            </label>
            <select id="model-select-mobile" v-model="selectedModel" class="form-select form-select-sm">
              <optgroup label="常用模型">
                <option value="deepseek-chat">Deepseek-Chat</option>
                <option value="gpt-3.5-turbo">GPT-3.5</option>
                <option value="gemini-1.5-flash">Gemini</option>
              </optgroup>
            </select>
          </div>
          <div class="mobile-buttons">
            <button class="btn btn-outline-secondary btn-sm" title="附加文件">
              <i class="fas fa-paperclip"></i>
            </button>
            <button 
              class="btn btn-sm" 
              :class="{ 
                'btn-primary voice-active': isPlaying, 
                'btn-outline-secondary': !isPlaying 
              }"
              @click="toggleVoicePlayback" 
              title="語音輸出"
            >
              <i class="fas" :class="{ 'fa-stop': isPlaying, 'fa-volume-up': !isPlaying }"></i>
            </button>
            <button class="btn btn-primary btn-sm" @click="handleSearchEnter" title="發送">
              <i class="fas fa-paper-plane"></i>
            </button>
          </div>
        </div>
      </div> -->

      <!-- 歌曲列表 -->
      <ul class="list-group">
        <li 
          v-for="song in filteredSongs" 
          :key="song.id" 
          class="list-group-item" 
          @mouseover="hoveredSong = song" 
          @mouseleave="hoveredSong = null" 
          @click="selectSong(song)"
          @dblclick="addToPlaylistAndConfirm(song)"
          :class="{ 
            'hovered': hoveredSong === song, 
            'selected': selectedSong && selectedSong.id === song.id 
          }"
        >
          <div class="row align-items-center">
            <!-- 視頻預覽區域 -->
            <div class="col-md-4">
              <!-- <div class="video-wrapper"> -->
              <div class="video-wrapper1">
                <!-- 視頻播放器 -->
                <video
                  v-if="canPlayVideo(song.synopsis)"
                  :key="song.id"
                  :src="videoUrls[song.id]"
                  :data-original-filename="song.synopsis"
                  class="preview-video"
                  preload="metadata"
                  muted
                  :controls="false"
                  autoplay
                  loop
                  @error="handleVideoError"
                  @loadstart="onLoadStart"
                  @loadeddata="onLoadedData"
                  @canplay="onCanPlay"
                >
                  <source 
                    :src="videoUrls[song.id]"
                    :type="getVideoType(song.synopsis)"
                  >
                </video>
                <!-- 備用顯示 -->
                <div v-else class="video-fallback">
                  <img 
                    v-if="song.synopsis && song.synopsis.includes('youtube.com')"
                    :src="getYoutubeThumbnail(song.synopsis)"
                    class="preview-image"
                    alt="YouTube 預覽圖"
                  >
                  <img 
                    v-else-if="song.album"
                    :src="song.album"
                    class="preview-image"
                    alt="專輯封面"
                    @error="handleImageError"
                  >
                  <div v-else class="format-notice">
                    暫無預覽圖片
                  </div>
                </div>
              </div>
            </div>

            <!-- 歌曲信息區域 -->
            <div class="col-md-6">
              <div class="text-white">
                <div class="song-info">
                  <div class="song-class">分類: {{ song.songclass }}</div>
                  <div class="song-name">歌名: {{ song.songname }}</div>
                </div>

                <div class="text-black">
                <div v-if="hoveredSong === song" class="popover bg-light p-2 rounded shadow">
                <!-- <p class="mb-0">通路＋版權費：{{ song.songChargeA }}+{{ song.songChargeB }}元</p> -->
                </div>
                </div>
              </div>
            </div>

            <!-- 價格信息區域 -->
            <div class="col-md-6">
              <!-- <div v-if="hoveredSong === song" class="popover bg-light p-2 rounded shadow">
                <p class="mb-0">通路＋版權費：{{ song.songChargeA }}+{{ song.songChargeB }}元</p>
              </div> -->
            </div>
          </div>
        </li>
          
          <!-- 修改分頁控制項結構 -->
      <li class="custom-pagination-item" v-if="!isMobile && totalPages > 1">
      <div class="custom-pagination-wrapper">
      <button 
        class="custom-pagination-btn prev"
        :class="{ 'disabled': !hasPrevious }"
        @click="prevPage">
        <i class="fas fa-chevron-left"></i> 上頁
      </button>
              <span class="custom-page-info">{{ currentPage }} / {{ totalPages }}</span>
      <button 
        class="custom-pagination-btn next"
        :class="{ 'disabled': !hasNext }"
        @click="nextPage">
        下頁 <i class="fas fa-chevron-right"></i>
      </button>
      </div>
      </li>

      </ul>
                
        <!-- 確認點歌彈窗 -->
        <div v-if="showModal" class="modal">
          <div class="modal-content" style="background-color: #6488b0;">
            <span class="close" @click="closeModal">×</span>
            <p>歌曲名稱: {{ selectedSong.songname }}</p>
            <!-- <p class="mb-0">通路＋版權費：本曲收費{{ selectedSong.songChargeA }}+{{ selectedSong.songChargeB }}元</p>
            <p>播放後收費，播放前可取消！</p> -->
            <button @click="addToPlaylistAndConfirm(selectedSong)">確認</button>
          </div>
      </div>

      <!-- 添加換行和分隔線 -->
      
        <!-- 移除分隔線，改用載入提示 -->
        <div v-if="isMobile" class="load-more-area" ref="loadMoreArea">
          <div v-if="isLoadingMore" class="loading-more-indicator">
            <div class="spinner-border text-light spinner-small" role="status">
              <span class="visually-hidden">載入中...</span>
            </div>
            <span class="loading-text">載入中...</span>
          </div>
          <div v-else 
            class="load-more-text" 
            @click="loadMoreData"
            :class="{ 'disabled': !hasNext }"
          >
            {{ hasNext ? '載入更多' : '已經到底了' }}
          </div>
        </div>
      
      <!-- OpenAI API 測試工具 - 簡化版 -->
      <div class="openai-container">
        <!-- 加載指示器 -->
        <div v-if="isLoading" class="loading-indicator">
          <div class="spinner-border text-light" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <div class="loading-text">{{ loadingText }}</div>
        </div>
        
        <!-- AI 回應 -->
        <div v-if="aiResult && !isLoading" class="ai-result mt-3">
          <div class="markdown-content" v-html="parsedAiResult"></div>
          <div class="bottom-spacing"></div>
          
          <!-- 社交媒體分享圖標 -->
          <div class="social-share-icons">
              <button class="btn btn-xs btn-outline-primary" @click="directShareToFacebook()" title="分享到臉書">
              <i class="fab fa-facebook-f"></i>
            </button>
              <button class="btn btn-xs btn-outline-success" @click="directShareToLine()" title="分享到LINE">
              <i class="fab fa-line"></i>
            </button>
            <button class="btn btn-xs btn-outline-success" @click="openShareDialog('wechat')" title="分享到微信">
              <i class="fab fa-weixin"></i>
            </button>
          </div>
        </div>
        
        <!-- 添加一個調試區域，顯示原始 AI 響應 -->
        <div v-if="aiResult && !isLoading" class="debug-area mt-2">
          <details>
            <summary>調試信息</summary>
            <pre>{{ aiResult }}</pre>
          </details>
        </div>
      </div>

      <!-- YouTube 搜索結果區域 - 使用與資料庫搜索結果一致的格式 -->
      <div class="youtube-results-container mt-4" v-if="youtubeSearchResults.length > 0 || isSearchingYouTube">
        <!-- 加載指示器 -->
        <div v-if="isSearchingYouTube" class="loading-indicator mb-3">
          <div class="spinner-border text-light" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <div class="loading-text">正在搜索 YouTube 視頻...</div>
        </div>
        
        <!-- YouTube 搜索結果 - 使用與資料庫搜索結果相同的 list-group 格式 -->
        <ul v-if="youtubeSearchResults.length > 0 && !isSearchingYouTube" class="list-group">
          <li 
            v-for="video in youtubeSearchResults" 
            :key="video.id" 
            class="list-group-item" 
            @click="playYouTubeVideo(video)"
            @dblclick="addYouTubeVideoToPlaylist(video)"
            style="cursor: pointer;"
          >
            <div class="row align-items-start">
              <!-- 視頻預覽區域 -->
              <div class="col-md-4">
                <div class="video-wrapper1 youtube-video-wrapper">
                  <div class="video-fallback youtube-thumbnail-fallback" style="position: relative; align-items: flex-start;">
                    <img 
                      :src="video.thumbnailHd || video.thumbnail || `https://i.ytimg.com/vi/${video.id}/mqdefault.jpg`"
                      class="preview-image youtube-thumbnail"
                      :alt="video.title"
                      @error="handleImageError"
                    >
                    <div class="position-absolute" style="top: 0.5rem; right: 0.5rem; z-index: 10;">
                      <span class="badge bg-danger" v-if="video.liveStatus === 'live'">LIVE</span>
                      <span class="badge bg-secondary" v-else>{{ formatDuration(video.duration) }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 視頻信息區域 -->
              <div class="col-md-6 d-flex align-items-center">
                <div class="text-white text-start w-100">
                  <div class="song-info">
                    <div class="song-class">頻道: {{ video.channelTitle }}</div>
                    <div class="song-name">標題: {{ video.title }}</div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>

      <!-- 分享對話框 -->
      <div v-if="showShareDialog" class="share-dialog-overlay" @click="closeShareDialog">
        <div class="share-dialog" @click.stop>
          <h4>分享內容</h4>
          <div class="form-group">
            <label for="share-content">內容</label>
            <textarea 
              id="share-content" 
              v-model="shareContent" 
              class="form-control" 
              rows="5"
            ></textarea>
          </div>
          <div class="form-group">
            <label for="share-signature">署名 (選填)</label>
            <input 
              id="share-signature" 
              v-model="shareSignature" 
              class="form-control" 
              placeholder="您的名字"
            />
          </div>
          <div v-if="currentSharePlatform === 'line'" class="share-tips">
            <i class="fas fa-info-circle"></i> 
            提示：點擊分享後，點擊"聊天室"選擇好友分享，點擊"Keep筆記"保存資料。
          </div>
          <div class="share-dialog-buttons">
            <button class="btn btn-secondary" @click="closeShareDialog">取消</button>
            <button class="btn btn-primary" @click="confirmShare">分享</button>
            </div>
          </div>
        </div>

        <!-- 添加一個處理中的提示框，在 isLoading 為 true 時顯示 -->
        <div v-if="isLoading" class="processing-overlay">
          <div class="processing-content">
            <div class="spinner-border text-light" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <div class="processing-text">{{ loadingText }}</div>
          </div>
        </div>

      </div>
    <!-- </div> -->
  </div>
</template>

<script setup>
// 導入所需的依賴
import { ref, onMounted, computed, nextTick, watch, onUnmounted } from 'vue';
import axios from 'axios';
import { usePlaylistStore } from '../store/usePlaylistStore.js';
import { useUserStore } from '@/store/useUserStore';

// 創建一個配置了的 axios 實例
// 動態設置 API base URL - 強制使用 ordersong API 路徑
const axiosInstance = axios.create({
  baseURL: '/ordersong/api',  // 強制使用 ordersong API 路徑
  timeout: 5000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'X-CSRFToken': getCookie('csrftoken')
  }
});

import { getCookie } from './csrf.js';
// 引入 Markdown 解析庫
import { marked } from 'marked';
// 或者
// import MarkdownIt from 'markdown-it';
// const md = new MarkdownIt();

// 狀態管理
const songs = ref([]); // 歌曲列表
const hasNext = ref(false); // 是否有下一頁
const searchQuery = ref(''); // 搜索關鍵字
const currentPage = ref(1);
const totalPages = ref(1);
const hasPrevious = ref(false);
const hoveredSong = ref(null); // 當前懸停的歌曲
const selectedSong = ref(null); // 當前選中的歌曲
const showModal = ref(false); // 是否顯示確認彈窗
const videoUrls = ref({}); // 視頻URL緩存
const selectedModel = ref('deepseek-chat'); // 預設選擇 Deepseek-Chat 模型
const enableVoiceOutput = ref(true); // 默認啟用語音輸出
const isPlaying = ref(false); // 是否正在播放語音
const voiceSpeed = ref(1.2); // 語音速度
const speechSynthesis = window.speechSynthesis; // 語音合成 API
let speechUtterance = null; // 語音合成實例
const loadingText = ref('正在處理請求，請稍候...'); // 加載提示文本
const aiPrompt = ref(''); // AI 提示輸入
const aiResult = ref(''); // AI 回應結果

// YouTube 搜索相關狀態
const youtubeSearchResults = ref([]); // YouTube 搜索結果
const isSearchingYouTube = ref(false); // 是否正在搜索 YouTube

// 從 store 中獲取播放列表相關方法
const { playlist, addSong, removeSong } = usePlaylistStore();
const userStore = useUserStore();

// 新增響應式變數
const isMobile = ref(false);
const isLoadingMore = ref(false);
const scrollContainer = ref(null);
const isScrolling = ref(false);
let scrollTimeout = null;

// 檢測是否為手機設備
onMounted(() => {
  checkMobile();
  window.addEventListener('resize', checkMobile);
});

onUnmounted(() => {
  window.removeEventListener('resize', checkMobile);
});

const checkMobile = () => {
  isMobile.value = window.innerWidth <= 768;
};

// 修改處理滾動事件的邏輯
const handleScroll = async () => {
  // 只在手機模式下啟用無限滾動
  if (!isMobile.value || isLoadingMore.value || !hasNext.value) return;

  const container = scrollContainer.value;
  if (!container) return;

  const scrollPosition = container.scrollTop;
  const scrollHeight = container.scrollHeight;
  const clientHeight = container.clientHeight;
  const distanceToBottom = scrollHeight - scrollPosition - clientHeight;

  // 當距離底部小於 200px 時載入更多
  if (distanceToBottom < 200) {
    try {
      isLoadingMore.value = true;
      
      const nextPage = currentPage.value + 1;
      const response = await fetchPage(searchQuery.value, nextPage, true); // 添加 isLoadMore 參數
      
      if (response?.members?.length > 0) {
        // 在手機模式下累加數據
        songs.value = [...songs.value, ...response.members];
        currentPage.value = response.current_page;
        hasNext.value = response.has_next;
        console.log(`已加載第 ${currentPage.value} 頁，總數: ${songs.value.length}`);
      } else {
        hasNext.value = false;
      }
    } catch (error) {
      console.error('載入更多數據時出錯:', error);
      hasNext.value = false;
    } finally {
      isLoadingMore.value = false;
    }
  }
};

// 修改 fetchPage 函數
const fetchPage = async (query = '', page = 1, isLoadMore = false) => {
  try {
    const response = await axiosInstance.get(`/search_members/?query=${query}&page=${page}`);
    const data = response.data;

    if (isMobile.value && isLoadMore) {
      // 手機版載入更多：保留現有數據，添加新數據
      if (page === 1) {
        songs.value = data.members || [];
      } else {
        songs.value = [...songs.value, ...data.members];
      }
    } else {
      // 桌面版或首次載入：替換數據
      songs.value = data.members || [];
    }

    // 更新分頁狀態
    currentPage.value = data.current_page;
    totalPages.value = data.total_pages;
    hasNext.value = data.has_next;
    hasPrevious.value = data.has_previous;

    return data;
  } catch (error) {
    console.error('Error fetching songs:', error);
    throw error;
  }
};

// 計算屬性：過濾後的歌曲列表
// 對應的 urls.py:
// path('search_members/', search_members, name='search_members')
// 對應的 views.py:
// def search_members(request):
//   query = request.GET.get('query', '')
//   page = request.GET.get('page', 1) # 在 views.py 中增加提示:
//   # print(f"搜尋關鍵字: {query}")
//   # print(f"當前頁碼: {page}")

const filteredSongs = computed(() => {
  if (!searchQuery.value) return songs.value;
  return songs.value.filter(song => {
    const searchTerm = searchQuery.value.toLowerCase();
    // 檢查歌曲名稱、歌手名稱、歌曲分類等是否包含搜尋關鍵字
    const songNameMatch = song.songname?.toLowerCase().includes(searchTerm) || false;
    const songClassMatch = song.songclass?.toLowerCase().includes(searchTerm) || false;
    const songStarMatch = song.songstar?.some(star => 
      star.starname?.toLowerCase().includes(searchTerm)
    ) || false;
    const songNumMatch = song.songnuchar?.toLowerCase().includes(searchTerm) || false;

    return songNameMatch || songClassMatch || songStarMatch || songNumMatch;
  });
});

// 提取共用的視頻初始化邏輯
const initializeVideos = async (songsList) => {
  for (const song of songsList) {
    if (song.synopsis) {
      videoUrls.value[song.id] = await getVideoUrl(song.synopsis, song.id);
      nextTick(() => {
        const video = document.querySelector(`video[data-original-filename="${song.synopsis}"]`);
        if (video) {
          video.muted = true;
          video.play().catch(err => {
            console.log('自動播放被阻止:', err);
          });
        }
      });
    }
  }
};

// 修改 search 函數
const search = async () => {
  try {
    // 重置所有狀態
    songs.value = [];
    currentPage.value = 1;
    hasNext.value = true;
    isLoadingMore.value = false;
    
    // 首次搜索不使用 isLoadMore
    const result = await fetchPage(searchQuery.value, 1, false);
    console.log('搜索完成:', result);
  } catch (error) {
    console.error('搜索出錯:', error);
  }
};

// 添加一個直接測試 API 的函數
const testDirectApiAccess = async () => {
  try {
    console.log('Testing direct API access...');
    
    // 只使用相對路徑
    const urls = [
      '/health_check/',
      '/search_members/?query=&page=1'
    ];
    
    for (const url of urls) {
      try {
        console.log(`Testing URL: ${url}`);
        const response = await axios.get(url, {
          timeout: 10000
        });
//         console.log(`Success for ${url}:`, response.data);
      } catch (error) {
        console.error(`Error for ${url}:`, error);
      }
    }
  } catch (error) {
    console.error('Error in testDirectApiAccess:', error);
  }
};

// 組件掛載時執行搜索
onMounted(async () => {
  try {
    console.log('Component mounted');
    
    // 檢測是否有來自語音客服小浮球的搜索關鍵字
    let voiceSearchQuery = null;
    
    // 優先檢查 URL 參數
    const urlParams = new URLSearchParams(window.location.search);
    const voiceSearchParam = urlParams.get('voice_search');
    if (voiceSearchParam) {
      voiceSearchQuery = decodeURIComponent(voiceSearchParam);
      console.log('🔍 檢測到 URL 參數中的語音搜索關鍵字:', voiceSearchQuery);
      // 清除 URL 參數（避免刷新時重複觸發）
      const newUrl = window.location.pathname;
      window.history.replaceState({}, '', newUrl);
    }
    
    // 如果沒有 URL 參數，檢查 sessionStorage
    if (!voiceSearchQuery && typeof sessionStorage !== 'undefined') {
      const storedQuery = sessionStorage.getItem('voice_search_query');
      const triggerFlag = sessionStorage.getItem('voice_search_trigger');
      
      if (storedQuery && triggerFlag === 'true') {
        voiceSearchQuery = storedQuery;
        console.log('🔍 檢測到 sessionStorage 中的語音搜索關鍵字:', voiceSearchQuery);
        
        // 清除 sessionStorage（避免重複觸發）
        sessionStorage.removeItem('voice_search_query');
        sessionStorage.removeItem('voice_search_trigger');
      }
    }
    
    // 如果有語音搜索關鍵字，設置搜索框並觸發 YouTube 搜索
    if (voiceSearchQuery && voiceSearchQuery.trim()) {
      searchQuery.value = voiceSearchQuery.trim();
      console.log('✅ 設置搜索關鍵字:', searchQuery.value);
      
      // 觸發 YouTube 搜索（參考 Dashboard.vue 的自定義標籤邏輯）
      await searchYouTubeVideos(searchQuery.value);
      
      // 同時執行 MySQL 資料庫搜索（保留原有功能）
      await search();
    } else {
      // 沒有語音搜索關鍵字，執行正常的初始化搜索
      // 測試直接 API 訪問
      await testDirectApiAccess();
      
      // 執行搜索
      console.log('Starting search...');
      search();
    }
  } catch (error) {
    console.error('Error in onMounted:', error);
  }
});

// 選擇歌曲
const selectSong = (song) => {
  selectedSong.value = song;
  showModal.value = true;
};

// 關閉確認彈窗
const closeModal = () => {
  showModal.value = false;
};

// 添加歌曲到播放列表並確認
const addToPlaylistAndConfirm = async (song) => {
  try {
    addSong({
      id: song.id,
      songname: song.songname,
      filename: song.filename,
      stateA: false,
      stateB: false,
    });

    // 準備請求數據 - 移除所有登入檢查，允許未登入用戶點歌
    let customerno = null;
    
    // 如果用戶已登入，嘗試獲取 customerno
    if (userStore.isLoggedIn && userStore.user && userStore.user.customer_id) {
      const customerId = userStore.user.customer_id;
      const parsedCustomerno = parseInt(customerId.replace('C', ''));
      if (!isNaN(parsedCustomerno)) {
        customerno = parsedCustomerno;
      }
    }
    
    // 構建請求數據
    const requestData = {
      songsname: parseInt(song.id),
    };
    
    // 只有在有 customerno 時才添加
    if (customerno !== null) {
      requestData.customerno = customerno;
    }
    
    console.log('axiosInstance baseURL:', axiosInstance.defaults.baseURL);
    console.log('請求 URL:', axiosInstance.defaults.baseURL + '/songsrequest/create/');
    console.log('請求數據:', requestData);
    
    await axiosInstance.post('/songsrequest/create/', requestData);
    console.log('點歌請求成功 - customerno:', customerno || 'null (未登入)', 'song.id:', song.id);
    showModal.value = false;
  } catch (error) {
    console.error('Error adding song to playlist:', error);
    alert('點歌失敗，請稍後再試');
  }
};

// 視頻相關工具函數
const canPlayVideo = (filename) => {
  if (!filename) return false;
  if (filename.includes('youtube.com')) return false;
  const ext = filename.split('.').pop().toLowerCase();
  const supportedFormats = ['mp4', 'webm', 'ogg', 'mkv'];
  return supportedFormats.includes(ext);
};

const getVideoType = (filename) => {
  if (!filename) return '';
  const ext = filename.split('.').pop().toLowerCase();
  const mimeTypes = {
    'mp4': 'video/mp4',
    'webm': 'video/webm',
    'ogg': 'video/ogg',
    'mov': 'video/quicktime',
    'avi': 'video/x-msvideo'
  };
  return mimeTypes[ext] || 'video/mp4';
};

// 獲取視頻URL
const getVideoUrl = async (filename, songId) => {
  if (!filename) return '';
  try {
    // 特殊文件處理
    if (filename.includes('李二萌')) {
      return '${import.meta.env.VITE_NGINX_URL}/年轻人就该出去溜达溜达 - 李二萌_prob5.mkv';
    }
    
    // 處理文件名
    let cleanFilename = filename;
    const match = filename.match(/^(.*?)-(.*?)(?:\(MTV\)|\[|$)/);
    if (match) {
      const [, singer, songName] = match;
      cleanFilename = `${singer.trim()}-${songName.trim()}`;
    }
    
    // 清理文件名
    cleanFilename = cleanFilename
      .replace(/\(MTV\).*?(\.[^.]+)$/, '$1')
      .replace(/\[.*?\]/g, '')
      .replace(/\s+/g, '-')
      .replace(/--+/g, '-')
      .replace(/-+(\.[^.]+)$/, '$1');
    
    // 確保有擴展名
    if (!cleanFilename.includes('.')) {
      cleanFilename += '.mp4';
    }
    
    // 嘗試從不同目錄加載視頻
    const encodedFilename = encodeURIComponent(cleanFilename);
    const synopsisUrl = `${import.meta.env.VITE_API_URL}/media/songs/synopsis/${encodedFilename}`;
    
    try {
      const response = await fetch(synopsisUrl, { method: 'HEAD' });
      return response.ok 
        ? synopsisUrl 
        : `${import.meta.env.VITE_API_URL}/media/songs/files/${encodedFilename}`;
    } catch (error) {
      return `${import.meta.env.VITE_API_URL}/media/songs/files/${encodedFilename}`;
    }
  } catch (error) {
    console.error('Error creating video URL:', error);
    return '';
  }
};

// 添加 isImageUrl 函數
const isImageUrl = (url) => {
  if (!url) return false;
  const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
  const extension = url.split('.').pop().toLowerCase();
  return imageExtensions.includes(extension);
};

// 修改 getFallbackImage 函數
const getFallbackImage = (song) => {
  if (!song || !song.album) {
    return '${import.meta.env.VITE_API_URL}/static/default-preview.jpg';
  }
  return song.album;
};

// 視頻加載事件處理器
const onLoadStart = (event) => {
  console.log('Video load started:', event.target.src);
};

const onLoadedData = (event) => {
  console.log('Video data loaded:', event.target.src);
};

const onCanPlay = (event) => {
  console.log('Video can play:', event.target.src);
};

// 視頻錯誤處理
const handleVideoError = async (event) => {
  const video = event.target;
  console.error('視頻加載錯誤:', video.error);
  
  try {
    const currentUrl = video.currentSrc;
    if (currentUrl.includes('/synopsis/')) {
      const newUrl = currentUrl.replace('/synopsis/', '/files/');
      video.src = newUrl;
    }
  } catch (error) {
    console.error('切換視頻源時出錯:', error);
  }
};

// 添加 YouTube 縮略圖獲取函數
const getYoutubeThumbnail = (url) => {
  const videoId = url.match(/(?:youtu\.be\/|youtube\.com(?:\/embed\/|\/v\/|\/watch\?v=|\/user\/\S+|\/ytscreeningroom\?v=|\/sandalsResorts#\w\/\w\/.*\/))([^\/&\?]{10,12})/);
  return videoId ? `https://img.youtube.com/vi/${videoId[1]}/hqdefault.jpg` : '';
};

// 修改 nextPage 方法
const nextPage = async () => {
  if (!hasNext.value) return;
  
  try {
    const nextPageNum = currentPage.value + 1;
    // 桌面版分頁不使用 isLoadMore
    await fetchPage(searchQuery.value, nextPageNum, false);
  } catch (error) {
    console.error('下一頁載入失敗:', error);
  }
};

// 修改 prevPage 方法
const prevPage = async () => {
  if (!hasPrevious.value) return;
  
  try {
    const prevPageNum = currentPage.value - 1;
    // 桌面版分頁不使用 isLoadMore
    await fetchPage(searchQuery.value, prevPageNum, false);
  } catch (error) {
    console.error('上一頁載入失敗:', error);
  }
};

// OpenAI API 相關狀態
const isLoading = ref(false);

// 添加計算屬性來解析 Markdown
const parsedAiResult = computed(() => {
  if (!aiResult.value) return '';
  
  try {
    console.log('解析 Markdown:', aiResult.value);
    // 使用 marked 解析 Markdown
    return marked(aiResult.value);
  } catch (error) {
    console.error('Markdown 解析錯誤:', error);
    return aiResult.value; // 如果解析失敗，返回原始文本
  }
});

// 處理搜索輸入
const handleSearchEnter = async () => {
  console.log('處理搜索輸入:', searchQuery.value);
  
  if (searchQuery.value.trim()) {
    // 如果輸入框有內容，則進行搜索
    // 1. 保留原有的 MySQL 資料庫搜索
    search();
    
    // 2. 取消大語言模型搜索功能（先備註掉）
    // // 同時將搜索查詢作為 AI 提示
    // aiPrompt.value = searchQuery.value;
    // // 設置加載狀態
    // isLoading.value = true;
    // loadingText.value = '正在思考中，請稍候...';
    // // 提交 AI 請求
    // await submitAiRequest();
    
    // 3. 改為 YouTube 搜索
    await searchYouTubeVideos(searchQuery.value);
    
    // 在手機模式下，滾動到結果區域
    if (window.innerWidth <= 768) {
      setTimeout(() => {
        const youtubeResultsContainer = document.querySelector('.youtube-results-container');
        if (youtubeResultsContainer) {
          youtubeResultsContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 300);
    }
  }
};

// 播放 AI 回應
const playAiResponse = () => {
  // 如果已經在播放，先停止
  if (isPlaying.value) {
    stopAiResponse();
    return; // 如果正在播放，停止後直接返回，不要開始新的播放
  }
  
  try {
    // 創建語音合成實例
    speechUtterance = new SpeechSynthesisUtterance();
    
    // 設置語音內容和語言
    speechUtterance.text = aiResult.value.replace(/<[^>]*>/g, ''); // 移除 HTML 標籤
    speechUtterance.lang = 'zh-TW'; // 繁體中文
    speechUtterance.rate = voiceSpeed.value; // 語速
    
    // 設置事件處理器
    speechUtterance.onend = () => {
      isPlaying.value = false;
      console.log('語音播放完成');
    };
    
    speechUtterance.onerror = (event) => {
      // 只有在非中斷錯誤時才記錄和處理
      if (event.error !== 'interrupted') {
        console.error('語音合成錯誤: ', event);
        isPlaying.value = false;
        alert('語音播放失敗，請稍後再試');
      } else {
        // 中斷錯誤是正常的，只需更新狀態
        isPlaying.value = false;
        console.log('語音播放被中斷');
      }
    };
    
    // 開始播放
    speechSynthesis.speak(speechUtterance);
    isPlaying.value = true;
    console.log('開始語音播放');
  } catch (error) {
    console.error('語音合成初始化錯誤:', error);
    isPlaying.value = false;
    alert('語音功能初始化失敗，請確保您的瀏覽器支持語音合成');
  }
};

// 停止 AI 回應播放
const stopAiResponse = () => {
  try {
    // 取消所有語音合成
    speechSynthesis.cancel();
    isPlaying.value = false;
    console.log('語音播放已停止');
  } catch (error) {
    console.error('停止語音合成時出錯:', error);
  }
};

// 切換語音播放
const toggleVoicePlayback = () => {
  if (isPlaying.value) {
    stopAiResponse();
  } else {
    playAiResponse();
  }
};

// 分享相關變量
const showShareDialog = ref(false);
const shareContent = ref('');
const shareSignature = ref('');
const currentSharePlatform = ref('');

// 打開分享對話框
const openShareDialog = (platform) => {
  // 只有微信需要顯示對話框
  if (platform === 'wechat') {
  currentSharePlatform.value = platform;
  
  // 準備分享內容 (去除 HTML 標籤)
  const plainText = aiResult.value.replace(/<[^>]*>/g, '');
  shareContent.value = plainText;
  
  // 如果用戶之前輸入過署名，使用保存的署名
  if (!shareSignature.value && localStorage.getItem('userSignature')) {
    shareSignature.value = localStorage.getItem('userSignature');
  }
  
  showShareDialog.value = true;
  }
};

// 關閉分享對話框
const closeShareDialog = () => {
  showShareDialog.value = false;
};

// 確認分享
const confirmShare = () => {
  // 保存用戶署名以便下次使用
  if (shareSignature.value) {
    localStorage.setItem('userSignature', shareSignature.value);
  }
  
  // 準備完整分享內容
  let finalContent = shareContent.value;
  
  // 添加署名
  if (shareSignature.value) {
    finalContent += `\n\n- ${shareSignature.value}`;
  }
  
  // 根據平台分享
  if (currentSharePlatform.value === 'facebook') {
    shareToFacebook(finalContent);
  } else if (currentSharePlatform.value === 'line') {
    shareToLine(finalContent);
  } else if (currentSharePlatform.value === 'wechat') {
    shareToWeChat(finalContent);
  }
  
  // 關閉對話框
  closeShareDialog();
};

// 分享到臉書
const shareToFacebook = (content) => {
  const url = encodeURIComponent(window.location.href);
  const title = encodeURIComponent(content);
  const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}&quote=${title}`;
  window.open(shareUrl, '_blank', 'width=600,height=400');
};

// 分享到 LINE
const shareToLine = (content) => {
  // 使用 LINE 的簡單分享方式，只傳遞文本內容
  // 這樣用戶可以直接選擇分享對象，而不需要處理 URL
  const text = encodeURIComponent(content);
  const shareUrl = `https://line.me/R/msg/text/?${text}`;
  
  // 使用較大的視窗打開
  window.open(shareUrl, '_blank', 'width=800,height=600');
};

// 分享到微信
const shareToWeChat = (content) => {
  // 微信分享通常需要使用微信 SDK，這裡僅顯示二維碼
  alert(`請使用微信掃描二維碼分享以下內容:\n\n${content}`);
  // 實際應用中，您可能需要生成二維碼或使用微信 SDK
};

// 找到 API 密鑰定義
const openaiApiKey = ref(import.meta.env.VITE_OPENAI_API_KEY || '');
const deepseekApiKey = ref(import.meta.env.VITE_DEEPSEEK_API_KEY || '');
const geminiApiKey = ref(import.meta.env.VITE_GEMINI_API_KEY || '');

// 提交 AI 請求
const submitAiRequest = async () => {
  try {
    console.log('提交 AI 請求:', aiPrompt.value);
    
    // 清空結果並顯示加載指示器
    isLoading.value = true;
    loadingText.value = '正在思考中...';
    aiResult.value = ''; // 清空結果，但保留 DOM 元素
    
    // 獲取 API 密鑰
    let openaiApiKey = import.meta.env.VITE_OPENAI_API_KEY;
    let deepseekApiKey = import.meta.env.VITE_DEEPSEEK_API_KEY;
    let geminiApiKey = import.meta.env.VITE_GEMINI_API_KEY;
    
    // 如果環境變量中沒有設置 API 密鑰，使用硬編碼的值
    if (!openaiApiKey) {
      console.log('使用硬編碼的 OpenAI API 密鑰');
      openaiApiKey = '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';
    }
    
    if (!deepseekApiKey) {
      console.log('未設置 Deepseek API 密鑰，將使用默認值');
      deepseekApiKey = 'sk-d80f9cdd385a44dab7a4bd37d60d77e9';
    }
    
    if (!geminiApiKey) {
      console.log('未設置 Gemini API 密鑰，將使用默認值');
      geminiApiKey = 'AIzaSyBW4xuPIL2CFS4pgX4lWorUCdV9Kz98NeY'; // 替換為您的 API 密鑰
    }
    
    // 根據選擇的模型調用相應的 API
    let result = '';
    
    try {
      if (selectedModel.value.startsWith('deepseek')) {
        loadingText.value = '正在使用 Deepseek 模型處理您的問題...';
        console.log('使用 Deepseek API，模型:', selectedModel.value);
        try {
          result = await callDeepseekAPI(aiPrompt.value, deepseekApiKey, selectedModel.value);
          console.log('Deepseek API 響應成功');
        } catch (deepseekError) {
          console.error('Deepseek API 調用失敗:', deepseekError);
          // 如果 Deepseek 失敗，嘗試 Gemini
          console.log('Deepseek API 調用失敗，切換到 Gemini API');
          result = await callGeminiAPI(aiPrompt.value, geminiApiKey, 'gemini-1.5-pro');
          console.log('Gemini API 響應成功 (備用)');
        }
      } else if (selectedModel.value.startsWith('gpt')) {
        loadingText.value = '正在使用 OpenAI 模型處理您的問題...';
        console.log('使用 OpenAI API，模型:', selectedModel.value);
        try {
          result = await callOpenAIAPI(aiPrompt.value, openaiApiKey, selectedModel.value);
          console.log('OpenAI API 響應成功');
        } catch (openaiError) {
          console.error('OpenAI API 調用失敗:', openaiError);
          // 如果 OpenAI 失敗，嘗試 Gemini
          console.log('OpenAI API 調用失敗，切換到 Gemini API');
          result = await callGeminiAPI(aiPrompt.value, geminiApiKey, 'gemini-1.5-pro');
          console.log('Gemini API 響應成功 (備用)');
        }
      } else if (selectedModel.value.startsWith('gemini')) {
        loadingText.value = '正在使用 Gemini 模型處理您的問題...';
        console.log('使用 Gemini API，模型:', selectedModel.value);
        result = await callGeminiAPI(aiPrompt.value, geminiApiKey, selectedModel.value);
        console.log('Gemini API 響應成功');
      }
      
      // 檢查結果是否為空
      if (!result || result.trim() === '') {
        console.error('API 返回空結果');
        throw new Error('API 返回空結果');
      }
      
      // 設置結果前更新加載文本
      loadingText.value = '處理完成，正在顯示結果...';
      
      // 設置結果
      aiResult.value = result;
      console.log('AI 響應成功:', aiResult.value);
      console.log('AI 結果已設置，長度:', aiResult.value?.length);
      
    } catch (error) {
      console.error(`${selectedModel.value} API 調用失敗:`, error);
      
      // 最後嘗試 Gemini
      try {
        console.log('所有 API 調用失敗，使用 Gemini API 作為最後嘗試');
        result = await callGeminiAPI(aiPrompt.value, geminiApiKey, 'gemini-1.5-pro');
        aiResult.value = result;
        console.log('Gemini API 響應成功 (最後嘗試)');
      } catch (finalError) {
        console.error('所有 API 調用都失敗:', finalError);
        aiResult.value = `抱歉，無法獲取 AI 響應。請稍後再試。`;
      }
    }
    
    // 無論成功或失敗，都在短暫延遲後關閉加載指示器
    setTimeout(() => {
      isLoading.value = false;
    }, 500); // 短暫延遲以確保用戶能看到處理完成的提示
  } catch (error) {
    console.error('AI 請求錯誤:', error);
    aiResult.value = `抱歉，處理請求時出錯: ${error.message}`;
    isLoading.value = false;
  } finally {
    // 無論成功或失敗，都在短暫延遲後關閉加載指示器
    setTimeout(() => {
      isLoading.value = false;
    }, 500); // 短暫延遲以確保用戶能看到處理完成的提示
  }
};

// YouTube 搜索函數（參考 Dashboard.vue 的邏輯）
const searchYouTubeVideos = async (query, maxResults = 30) => {
  console.log('🔍 開始 YouTube 搜索，關鍵字:', query);
  
  if (!query || !query.trim()) {
    console.log('⚠️ 搜索關鍵字為空');
    return;
  }
  
  // 清空先前的搜索結果
  youtubeSearchResults.value = [];
  isSearchingYouTube.value = true;
  
  try {
    // 調用 SnapTV 的 YouTube API
    const response = await fetch('https://tv.dailylife.xin/api/videos/youtube_search/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        tags: [query], // 將搜索關鍵字作為標籤傳遞
        max_results: maxResults
      }),
      // 增加超時時間到 120 秒
      signal: AbortSignal.timeout(120000)
    });

    // 檢查響應狀態
    if (!response.ok) {
      if (response.status === 504) {
        const errorText = await response.text().catch(() => 'Gateway Timeout');
        console.error('❌ 504 Gateway Timeout - 後端處理超時');
        throw new Error('搜索請求超時（504），請稍後再試');
      }
      
      let errorMessage = `HTTP ${response.status}: ${response.statusText}`;
      try {
        const errorData = await response.json();
        errorMessage = errorData.error || errorData.message || errorMessage;
      } catch (e) {
        const errorText = await response.text().catch(() => '');
        if (errorText && !errorText.startsWith('<')) {
          errorMessage = errorText;
        }
      }
      
      throw new Error(`搜索請求失敗: ${errorMessage}`);
    }

    // 嘗試解析 JSON
    let data;
    try {
      const responseText = await response.text();
      if (responseText.trim().startsWith('<')) {
        console.error('❌ 收到 HTML 響應而非 JSON:', responseText.substring(0, 200));
        throw new Error('後端返回了錯誤頁面而非 JSON 數據');
      }
      data = JSON.parse(responseText);
    } catch (parseError) {
      console.error('❌ JSON 解析失敗:', parseError);
      throw new Error('無法解析後端響應');
    }
    
    console.log('📡 YouTube API 響應:', data);
    
    if (data.success && data.videos && data.videos.length > 0) {
      console.log('✅ YouTube API 成功，找到', data.videos.length, '個視頻');
      youtubeSearchResults.value = data.videos;
    } else {
      console.error('❌ YouTube API 搜索失敗:', data.error || '未知錯誤');
      youtubeSearchResults.value = [];
      alert('YouTube 搜索失敗，請檢查網絡連接');
    }
    
  } catch (error) {
    console.error('❌ YouTube 搜索請求失敗:', error);
    youtubeSearchResults.value = [];
    
    let errorMessage = error.message || '未知錯誤';
    if (error.name === 'AbortError' || errorMessage.includes('timeout') || errorMessage.includes('超時')) {
      errorMessage = '搜索請求超時（超過 120 秒），請稍後再試';
    } else if (errorMessage.includes('504')) {
      errorMessage = '服務器響應超時（504 Gateway Timeout），請稍後再試';
    }
    
    alert('YouTube 搜索失敗: ' + errorMessage);
  } finally {
    isSearchingYouTube.value = false;
    console.log('YouTube 搜索完成，結果數量:', youtubeSearchResults.value.length);
  }
};

// YouTube 視頻處理函數
const playYouTubeVideo = (video) => {
  // 將 YouTube 視頻加入播放列表（playerhc.vue 會自動使用嵌入式播放器播放）
  const youtubeUrl = `https://www.youtube.com/watch?v=${video.id}`;
  addSong({
    id: video.id,
    songname: video.title,
    filename: youtubeUrl,
    stateA: false,
    stateB: false,
  });
  console.log('✅ YouTube 視頻已加入播放列表:', video.title);
};

const addYouTubeVideoToPlaylist = (video) => {
  // 將 YouTube 視頻加入播放列表（雙擊時只加入，不立即播放）
  addSong({
    id: video.id,
    songname: video.title,
    filename: `https://www.youtube.com/watch?v=${video.id}`,
    stateA: false,
    stateB: false,
  });
  console.log('✅ YouTube 視頻已加入播放列表:', video.title);
};

// 格式化視頻時長
const formatDuration = (duration) => {
  if (!duration) return '未知';
  // 處理 ISO 8601 格式的時長（如 PT1H2M10S）
  const match = duration.match(/PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/);
  if (!match) return duration;
  
  const hours = parseInt(match[1] || 0);
  const minutes = parseInt(match[2] || 0);
  const seconds = parseInt(match[3] || 0);
  
  if (hours > 0) {
    return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  } else {
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  }
};

// 格式化觀看次數
const formatViewCount = (count) => {
  if (count >= 1000000) {
    return (count / 1000000).toFixed(1) + 'M';
  } else if (count >= 1000) {
    return (count / 1000).toFixed(1) + 'K';
  }
  return count.toString();
};

// 修改 Gemini API 調用函數
const callGeminiAPI = async (prompt, apiKey, modelName = 'gemini-1.5-pro') => {
  try {
    console.log('調用 Gemini API，模型:', modelName);
    
    // 構建正確的 API 端點
    const url = `https://generativelanguage.googleapis.com/v1/models/${modelName}:generateContent`;
    
    // 添加繁體中文和 Markdown 格式指示作為提示的一部分
    const enhancedPrompt = `
你是一個有用的助手。請始終使用繁體中文回答問題，即使用戶使用其他語言提問。請使用 Markdown 格式來組織你的回答，使其更易於閱讀。

用戶問題：${prompt}
`;
    
    // 準備請求體
    const requestBody = {
      contents: [
        {
          parts: [
            {
              text: enhancedPrompt
            }
          ]
        }
      ],
      generationConfig: {
        temperature: 0.7,
        maxOutputTokens: 2048,
      }
    };
    
    const response = await fetch(`${url}?key=${apiKey}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody)
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Gemini API 錯誤: ${errorData.error?.message || '未知錯誤'}`);
    }
    
    const data = await response.json();
    console.log('Gemini API 響應:', data);
    
    if (data.candidates && data.candidates[0] && data.candidates[0].content) {
      console.log('Gemini 返回的文本:', data.candidates[0].content.parts[0].text);
      return data.candidates[0].content.parts[0].text;
    } else {
      throw new Error('無法從 Gemini API 獲取有效響應');
    }
  } catch (error) {
    console.error('Gemini API 調用失敗:', error);
    throw error;
  }
};

// 在組件卸載時停止任何正在播放的語音
onMounted(() => {
  window.addEventListener('beforeunload', stopAiResponse);
  
  // 預加載語音
  if ('speechSynthesis' in window) {
    speechSynthesis.getVoices();
  }
});

// 添加自動調整高度的方法
const searchTextarea = ref(null);

const onInputChange = (event) => {
  // 調用原有的搜索方法
  search(event);
  
  // 自動調整高度
  autoResizeTextarea();
};

const autoResizeTextarea = () => {
  if (!searchTextarea.value) return;
  
  // 重置高度以獲取正確的 scrollHeight
  searchTextarea.value.style.height = 'auto';
  
  // 設置新高度
  const newHeight = Math.max(
    searchTextarea.value.scrollHeight,
    38 // 最小高度，與原輸入框高度一致
  );
  
  searchTextarea.value.style.height = `${newHeight}px`;
};

// 監聽 searchQuery 變化，確保在值變化時也調整高度
watch(() => searchQuery.value, () => {
  nextTick(() => {
    autoResizeTextarea();
  });
});

// 在組件掛載後初始化
onMounted(() => {
  autoResizeTextarea();
});

// 修復 OpenAI API 調用函數
const callOpenAIAPI = async (prompt, apiKey, model = 'gpt-3.5-turbo') => {
  try {
    console.log('調用 OpenAI API，模型:', model);
    
    // 添加繁體中文和 Markdown 格式指示
    const enhancedPrompt = `請使用繁體中文回答以下問題，並使用 Markdown 格式來組織你的回答，包括適當的標題、列表、代碼塊等。問題：${prompt}`;
    
    const response = await fetch('https://api.openai.com/v1/chat/completions', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiKey}`
      },
      body: JSON.stringify({
        model: model,
        messages: [
          {
            role: 'system',
            content: '你是一個有用的助手。請始終使用繁體中文回答問題，即使用戶使用其他語言提問。請使用 Markdown 格式來組織你的回答，使其更易於閱讀。'
          },
          {
            role: 'user',
            content: enhancedPrompt
          }
        ],
        temperature: 0.7,
        max_tokens: 2048
      })
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`OpenAI API 錯誤: ${errorData.error?.message || '未知錯誤'}`);
    }
    
    const data = await response.json();
    console.log('OpenAI API 響應:', data);
    
    if (data.choices && data.choices[0] && data.choices[0].message) {
      console.log('OpenAI 返回的文本:', data.choices[0].message.content);
      return data.choices[0].message.content;
    } else {
      console.error('OpenAI API 響應格式不正確:', data);
      throw new Error('無法從 OpenAI API 獲取有效響應');
    }
  } catch (error) {
    console.error('OpenAI API 調用失敗:', error);
    throw error;
  }
};

// 修復 Deepseek API 調用函數
const callDeepseekAPI = async (prompt, apiKey, model = 'deepseek-chat') => {
  try {
    console.log('調用 Deepseek API，模型:', model);
    
    // 添加繁體中文和 Markdown 格式指示
    const enhancedPrompt = `請使用繁體中文回答以下問題，並使用 Markdown 格式來組織你的回答，包括適當的標題、列表、代碼塊等。問題：${prompt}`;
    
    const response = await fetch('https://api.deepseek.com/v1/chat/completions', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiKey}`
      },
      body: JSON.stringify({
        model: model === 'deepseek-chat' ? 'deepseek-chat' : 'deepseek-coder',
        messages: [
          {
            role: 'system',
            content: '你是一個有用的助手。請始終使用繁體中文回答問題，即使用戶使用其他語言提問。請使用 Markdown 格式來組織你的回答，使其更易於閱讀。'
          },
          {
            role: 'user',
            content: enhancedPrompt
          }
        ],
        temperature: 0.7,
        max_tokens: 2048
      })
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Deepseek API 錯誤: ${errorData.error?.message || '未知錯誤'}`);
    }
    
    const data = await response.json();
    console.log('Deepseek API 響應:', data);
    
    if (data.choices && data.choices[0] && data.choices[0].message) {
      console.log('Deepseek 返回的文本:', data.choices[0].message.content);
      return data.choices[0].message.content;
    } else {
      console.error('Deepseek API 響應格式不正確:', data);
      throw new Error('無法從 Deepseek API 獲取有效響應');
    }
  } catch (error) {
    console.error('Deepseek API 調用失敗:', error);
    throw error;
  }
};

// 直接分享到臉書（不顯示編輯對話框）
const directShareToFacebook = () => {
  try {
    // 獲取純文本內容（去除HTML標籤）
    const plainText = aiResult.value.replace(/<[^>]*>/g, '');
    
    // 編碼URL和內容
    const url = encodeURIComponent(window.location.href);
    const content = encodeURIComponent(plainText);
    
    // 構建分享URL - 使用 FB 的標準分享 API
    const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}&quote=${content}`;
    
    // 打開分享窗口 - 使用較大的窗口尺寸
    const width = 600;
    const height = 500;
    const left = (window.innerWidth - width) / 2;
    const top = (window.innerHeight - height) / 2;
    
    window.open(
      shareUrl,
      'facebook-share-dialog',
      `width=${width},height=${height},top=${top},left=${left},toolbar=0,location=0,menubar=0,scrollbars=1,resizable=1`
    );
    
    console.log('臉書分享 URL:', shareUrl);
  } catch (error) {
    console.error('臉書分享錯誤:', error);
    alert('分享到臉書時發生錯誤，請稍後再試');
  }
};

// 直接分享到LINE（不顯示編輯對話框）
const directShareToLine = () => {
  try {
    // 獲取純文本內容（去除HTML標籤）
    const plainText = aiResult.value.replace(/<[^>]*>/g, '');
    
    // 編碼內容
    const content = encodeURIComponent(plainText);
    
    // 構建分享URL
    const shareUrl = `https://line.me/R/msg/text/?${content}`;
    
    // 打開分享窗口
    window.open(shareUrl, '_blank', 'width=800,height=600');
    
    console.log('LINE分享 URL:', shareUrl);
  } catch (error) {
    console.error('LINE分享錯誤:', error);
    alert('分享到LINE時發生錯誤，請稍後再試');
  }
};

// 新增載入更多數據的方法
const loadMoreData = async () => {
  if (!hasNext.value || isLoadingMore.value) return;

  try {
    isLoadingMore.value = true;
    const nextPage = currentPage.value + 1;
    const response = await fetchPage(searchQuery.value, nextPage, true);
    
    if (response?.members?.length > 0) {
      songs.value = [...songs.value, ...response.members];
      currentPage.value = response.current_page;
      hasNext.value = response.has_next;
      console.log(`已加載第 ${currentPage.value} 頁，總數: ${songs.value.length}`);
    } else {
      hasNext.value = false;
    }
  } catch (error) {
    console.error('載入更多數據時出錯:', error);
    hasNext.value = false;
  } finally {
    isLoadingMore.value = false;
  }
};

// 監聽滾動事件
onMounted(() => {
  const container = scrollContainer.value;
  if (container) {
    container.addEventListener('scroll', handleScroll, { passive: true });
    console.log('已添加滾動事件監聽器');
  }
});

onUnmounted(() => {
  const container = scrollContainer.value;
  if (container) {
    container.removeEventListener('scroll', handleScroll);
  }
});
</script>

<style scoped>
/* 列表項樣式 */
.list-group-item {
  margin-bottom: 0.5rem;
  background-color: rgba(0, 0, 0, 0.5) !important;
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 0.5rem;
}

/* 視頻容器基本樣式 */
.video-wrapper1 {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%; 
  background: #000;
  overflow: hidden;
  margin-bottom: 0rem;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

/* 視頻元素樣式 */
.preview-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  background-color: #000;
}

/* 列表項布局 */
.row {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
}

.col-md-4 {
  flex: 0 0 33.333333%;
  max-width: 33.333333%;
}

.col-md-6 {
  flex: 0 0 50%;
  max-width: 50%;
}

/* 移動端樣式 */
@media (max-width: 768px) {
  .col-md-4, .col-md-6 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .list-group-item {
    padding: 0.25rem;
    max-height: 385px; /* 從原來的 400px 減少 15px */
    overflow: hidden;
    /* background-color: rgba(255, 255, 255, 0); */
  }

  .video-wrapper1 {
    width: 100%;
    /* padding-bottom: 56.25%;  */
    /* max-width: 320px;  */
    /* margin: 0 auto 0.5rem auto; */
  }

  .ai-controls {
    margin-bottom: 0.5rem !important;
  }
  
  .model-select-container {
    margin-bottom: 0.5rem;
  }
  
  .form-select {
    height: 2rem;
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  
  .btn-xs {
    padding: 0.25rem 0.5rem;
  }
  
  .search-container {
    margin-bottom: 0.5rem;
  }
  
  .auto-resize-textarea {
    padding: 0.25rem;
    min-height: 2rem;
  }
}

/* 超小屏幕的特殊處理 */
@media (max-width: 480px) {
  .video-wrapper1 {
    margin-top: 0.5rem;
    padding-top: 0.25rem;
    width: 100%;
    max-width: 100%;
  }
  
  .list-group-item {
    max-height: 320px; /* 確保在超小屏幕上也應用相同的高度減少 */
    padding-bottom: 0.15rem; /* 減少底部內邊距 */
  }
}

/* 單獨為手機模式下的預覽圖片添加樣式 */
@media (max-width: 480px) {
  .song-preview .preview-image {
    width: 100% !important; /* 放大到 150% */
    max-width: 100% !important;
    object-fit: cover !important; /* 確保圖片填滿容器 */
    object-position: center top !important; /* 靠上對齊 */
    margin-top: 10% !important;  /* 進一步向上調整 */
   
  }
  
  /* .song-preview .video-fallback { */
    /* overflow: hidden !important; 確保溢出的圖片被裁剪 */
  /* } */
}

/* 互動狀態樣式 */
.hovered {
  background-color: lightgray;
}

.selected {
  background-color: lightblue;
}

/* 文字顏色 */
.text-white {
  color: white !important;
}

/* 彈窗樣式 */
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 200000; /* 確保在待播歌區之上 */
}

.modal-content {
  background-color: #6488b0;
  padding: 20px;
  border-radius: 5px;
  width: 80%;
  max-width: 500px;
  position: relative;
  z-index: 200001; /* 比 modal 背景更高 */
}

.page-end-line {
  border: 1;
  height: 10px;
  background: rgb(50, 10, 10);
  margin: 0.5rem 0;
}

.video-fallback {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 8px;
}

.preview-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 8px;
}

.format-notice {
  color: white;
  text-align: center;
  padding: 1rem;
  font-size: 0.9rem;
  opacity: 0.8;
}

/* 完全重寫分頁樣式，使用新的類名 */
/* .custom-pagination-item {
  width: 100%;
  display: block;
  margin: 10px 0;
  padding: 0;
  background: none;
  list-style: none;
}

.custom-pagination-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  width: auto;
  max-width: 100%;
  margin: 0 auto;
  padding: 5px 10px;
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  white-space: nowrap;
}

.custom-pagination-btn {
  display: inline-block;
  white-space: nowrap;
  padding: 5px 10px;
  margin: 0 5px;
  border: none;
  border-radius: 5px;
  background-color: #343a40;
  color: white;
  font-size: 0.9rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.custom-pagination-btn:hover:not(.disabled) {
  background-color: #495057;
}

.custom-pagination-btn.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.custom-page-info {
  display: inline-block;
  white-space: nowrap;
  padding: 5px;
  margin: 0 5px;
  color: white;
  font-size: 0.9rem;
} */

.custom-pagination-item {
  width: 100%;
  display: block;
  margin: 10px 0;
  padding: 0;
  background: none;
  list-style: none;
}

.custom-pagination-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  margin: 0.5rem 0;
}

.custom-pagination-btn {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.3rem 0.8rem;
  border: none;
  border-radius: 15px;
  background: linear-gradient(145deg, #007bff, #0056b3);
  color: white;
  font-weight: normal;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.custom-pagination-btn:hover:not(.disabled) {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
}

.custom-pagination-btn.disabled {
  background: #e0e0e0;
  cursor: not-allowed;
  opacity: 0.7;
}

.custom-page-info {
  font-size: 0.9rem;
  color: #666;
  padding: 0.3rem 0.8rem;
  background-color: #f8f9fa;
  border-radius: 12px;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.05);
}

.fas {
  font-size: 0.8rem;
}

/* 手機模式下的特殊樣式 */
@media (max-width: 768px) {
  .custom-pagination-wrapper {
    padding: 3px 8px;
    transform: scale(0.9);
  }
  
  .custom-pagination-btn {
    padding: 3px 8px;
    margin: 0 3px;
    font-size: 0.85rem;
  }
  
  .custom-page-info {
    padding: 3px;
    margin: 0 3px;
    font-size: 0.85rem;
  }
}

/* 超小屏幕的特殊處理 */
@media (max-width: 480px) {
  .custom-pagination-wrapper {
    padding: 2px 5px;
    transform: scale(0.85);
  }
  
  .custom-pagination-btn {
    padding: 2px 5px;
    margin: 0 2px;
    font-size: 0.8rem;
  }
  
  .custom-page-info {
    padding: 2px;
    margin: 0 2px;
  font-size: 0.8rem;
  }

  .page-end-line {
  border: 1;
  height: 5px;
  background: rgb(50, 10, 10);
  margin-top: -160px;
}
}

/* 其他樣式保持不變 */
/* ... */

/* 調試區域樣式 */
.debug-area {
  display: none !important;
}

/* 徹底移除所有滾動條 */
html, body, div, .container, .markdown-content, .openai-container,
.list-group, .modal-content, textarea, pre, code {
  scrollbar-width: none !important; /* Firefox */
  -ms-overflow-style: none !important; /* IE and Edge */
}

html::-webkit-scrollbar, 
body::-webkit-scrollbar, 
div::-webkit-scrollbar, 
.container::-webkit-scrollbar,
.markdown-content::-webkit-scrollbar,
.openai-container::-webkit-scrollbar,
.list-group::-webkit-scrollbar,
.modal-content::-webkit-scrollbar,
textarea::-webkit-scrollbar,
pre::-webkit-scrollbar,
code::-webkit-scrollbar {
  width: 0 !important;
  height: 0 !important;
  display: none !important; /* Chrome, Safari, Opera */
}

/* 確保內容可以滾動但沒有滾動條 */
.markdown-content {
  overflow: auto !important;
  max-height: none !important; /* 移除可能限制高度的設置 */
}

/* 手機模式下的 AI 控制區域優化 */
@media (max-width: 768px) {
  .ai-controls {
    margin-bottom: 0.5rem !important;
  }
  
  .model-select-container {
    margin-bottom: 0.5rem;
  }
  
  .form-select {
    height: 2rem;
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  
  .btn-xs {
    padding: 0.25rem 0.5rem;
  }
  
  .search-container {
    margin-bottom: 0.5rem;
  }
  
  .auto-resize-textarea {
    padding: 0.25rem;
    min-height: 2rem;
  }
  
  /* 確保列表底部有足夠空間 */
  .list-group {
    margin-bottom: 80px; /* 增加底部間距，避免被 footer 遮擋 */
    padding-bottom: 20px;
  }
  
  /* 確保分頁控制項在小屏幕上可見 */
  /* .pagination-li {
    margin-bottom: 30px; 
  } */
  
  /* 確保 AI 結果區域在手機上有足夠的可見度 */
  .openai-container {
    margin-bottom: 120px; /* 增加底部間距，確保內容完全可見 */
    padding-bottom: 50px; /* 額外的底部填充 */
  }
  
  /* 確保分享按鈕在手機上不被遮擋 */
  .social-share-icons {
    margin-bottom: 50px;
    padding-bottom: 30px;
  }
}

/* AI 控制區域容器 */
.ai-controls-container {
  display: flex;
  flex-direction: column;
}

/* 按鈕容器 */
.action-buttons {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

/* 模型選擇容器 */
.model-select-container {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

/* 響應式調整 */
@media (max-width: 768px) {
  .ai-controls-container .row {
    margin: 0;
  }
  
  .action-buttons {
    margin-top: 0.5rem;
    justify-content: flex-start;
  }
}

/* 手機版控制區域 */
.mobile-controls {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.mobile-select-container {
  display: flex;
  align-items: center;
  width: 60%; /* 控制選擇框寬度 */
}

.mobile-select-container .form-select {
  font-size: 0.8rem;
  height: 2rem;
  padding: 0.25rem 0.5rem;
}

.mobile-buttons {
  display: flex;
  gap: 0.3rem; /* 減小按鈕間距 */
}

.mobile-buttons .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.8rem;
}

/* 響應式調整 */
@media (max-width: 768px) {
  .model-icon {
    font-size: 0.9rem;
  }
  
  .mobile-select-container .form-select {
    max-width: 100%;
  }


.song-preview {
  width: 180px;
  height: 100px;
  overflow: hidden;
  border-radius: 5px;
  flex-shrink: 0;
  position: relative;
  z-index: 20;
  background-color: #333;
  display: flex;
  align-items: center;
  justify-content: center;
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 30;
  display: block;
}
}

/* @media (max-width: 480px) {
  .song-preview .preview-image {
    width: 150% !important;
    max-width: 150% !important;
    object-fit: cover !important;
    object-position: center top !important;
    margin-top: -10% !important;
  }

  .video-fallback {
    margin-top: 1px;
    display: flex;
    justify-content: center;
    align-items: center; */
    /* 移除 transform: scale() 因為無法正常運作 */
    /* width: 150%;
    max-width: 150%;
  }
} */


/* 手機模式下的特殊樣式 */
@media (max-width: 480px) {
  .song-info {
    text-align: left;
    padding-left: 10px;
    padding-top: 10px;
  }
  
  .song-class, .song-name {
    margin-top: 10px;
  }
  
  /* 進一步增加底部間距 */
  .openai-container {
    margin-bottom: 150px;
    padding-bottom: 70px;
  }
  
  .social-share-icons {
    margin-bottom: 70px;
    padding-bottom: 40px;
  }
}


/* 處理中提示框樣式 */
.processing-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(3px);
}

.processing-content {
  background-color: rgba(0, 0, 0, 0.8);
  border-radius: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 0 20px rgba(0, 123, 255, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.1);
  max-width: 80%;
}

.processing-text {
  color: white;
  margin-top: 15px;
  text-align: center;
  font-size: 1rem;
}

/* 針對手機模式的優化 */
@media (max-width: 768px) {
  .processing-content {
    padding: 15px;
  }
  
  .processing-text {
    font-size: 0.9rem;
  }
  
  /* 確保 AI 結果區域在手機上有足夠的可見度 */
  .openai-container {
    margin-bottom: 100px; /* 增加底部間距，確保內容完全可見 */
  }
}

/* 搜索容器樣式 */
.search-container {
  margin-bottom: 1rem;
}

/* 移動端樣式優化 */
@media (max-width: 768px) {
  .search-container {
    margin-bottom: 0.5rem;
    margin-top: 0; /* 移除頂部間距 */
  }
  
  .auto-resize-textarea {
    padding: 0.25rem;
    min-height: 2rem;
    margin-top: 0 !important; /* 移除頂部間距 */
  }
  
  .ai-controls {
    margin-bottom: 0.5rem !important;
    margin-top: 0 !important; /* 移除頂部間距 */
  }
}

/* 超小屏幕的特殊處理 */
@media (max-width: 480px) {
  .search-container {
    margin-bottom: 0.25rem;
  }
  
  .auto-resize-textarea {
    padding: 0.15rem;
    min-height: 1.8rem;
    font-size: 0.9rem !important;
  }
  
  /* 調整 AI 控制區域的間距 */
  .ai-controls-container {
    padding: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  
  /* 調整按鈕大小 */
  .btn-xs {
    padding: 0.15rem 0.4rem !important;
    font-size: 0.8rem !important;
  }
}

/* 確保整個容器可以滾動到底部 */
.container {
  padding-bottom: 150px !important; /* 增加底部間距 */
  min-height: 100vh !important; /* 確保容器至少有一個視窗高度 */
  overflow-y: auto !important; /* 確保可以滾動 */
  -webkit-overflow-scrolling: touch !important; /* 增加 iOS 滾動支持 */
}

/* 確保 AI 結果區域在手機上有足夠的可見度 */
.openai-container {
  margin-bottom: 120px !important; /* 增加底部間距，確保內容完全可見 */
}

/* 確保分頁按鈕可見 */
.pagination-container {
  margin-bottom: 200px !important; /* 增加底部間距 */
  padding-bottom: 100px !important;
  position: relative !important; /* 確保分頁按鈕在上層 */
  z-index: 900 !important; /* 確保分頁按鈕在上層 */
}

/* 手機模式下的特殊樣式 */
@media (max-width: 768px) {
  .container {
    padding-bottom: 200px !important; /* 在手機模式下增加更多底部間距 */
    overflow-y: auto !important; /* 強制啟用垂直滾動 */
    -webkit-overflow-scrolling: touch !important;
  }
  
  .pagination-container {
    margin-bottom: 250px !important; /* 在手機模式下增加更多底部間距 */
    padding-bottom: 150px !important;
  }
  
  /* 確保內容可滾動 */
  body, html, #app, .main-content, .scrollable-content {
    overflow-y: auto !important;
    height: auto !important;
    min-height: 100% !important;
    -webkit-overflow-scrolling: touch !important;
  }
}

/* 超小屏幕的特殊處理 */
@media (max-width: 480px) {
  .container {
    padding-bottom: 250px !important; /* 在超小屏幕上進一步增加底部間距 */
  }
  
  .pagination-container {
    margin-bottom: 300px !important; /* 在超小屏幕上進一步增加底部間距 */
    padding-bottom: 200px !important;
  }
}

/* 修正滾動問題 */
.song-list-container {
  overflow-y: auto !important; /* 改為 auto，確保可以滾動 */
  height: auto !important;
  min-height: 100vh !important;
  -webkit-overflow-scrolling: touch !important; /* 增加 iOS 滾動支持 */
}

/* 添加一個固定高度的滾動容器 */
.scrollable-song-container {
  height: 100vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  position: relative;
  padding-bottom: 60px;
}

/* 確保整個容器可以滾動到底部 */
.container {
  padding-bottom: 150px !important;
  min-height: auto !important; /* 改為自動高度，不要強制 100vh */
  overflow-y: visible !important; /* 改為可見溢出 */
}

/* 確保歌曲列表容器可滾動 */
.song-list-container {
  overflow-y: visible !important; /* 改為可見溢出 */
  height: auto !important;
  min-height: auto !important; /* 改為自動高度 */
}

/* 確保分頁按鈕可見 */
.pagination-container {
  margin-bottom: 50px !important;
  padding-bottom: 20px !important;
  position: relative !important;
  z-index: 900 !important;
  height: auto !important;
  min-height: auto !important;
  width: 100% !important; /* 確保容器寬度為100% */
}

/* 手機模式下的特殊樣式 */
@media (max-width: 768px) {
  .scrollable-song-container {
    height: calc(100vh - 60px) !important; /* 在手機模式下減少高度 */
    padding-bottom: 200px !important;
  }
  
  .container {
    padding-bottom: 200px !important;
    overflow-y: visible !important;
  }
  
  /* 確保內容可滾動 */
  body, html, #app, .main-content, .scrollable-content {
    overflow-y: auto !important;
    height: auto !important;
    min-height: 100% !important;
    -webkit-overflow-scrolling: touch !important;
  }
}

/* 超小屏幕的特殊處理 */
@media (max-width: 480px) {
  .scrollable-song-container {
    height: calc(100vh - 120px) !important; /* 在超小屏幕上進一步減少高度 */
    padding-bottom: 250px !important;
  }
  
  .container {
    padding-bottom: 250px !important;
  }
  
  .pagination-container {
    margin-bottom: 20px !important;
    padding-bottom: 10px !important;
    width: 100% !important;
  }
}

/* 修復滾動問題 - 強制設置滾動區域 */
.container, .song-list-container, .openai-container {
  max-height: calc(100vh - 100px) !important; /* 進一步增加最大高度，從150px減少到100px */
  overflow-y: auto !important; /* 啟用垂直滾動 */
  -webkit-overflow-scrolling: touch !important; /* 增加 iOS 滾動支持 */
  position: relative !important;
}

/* 確保整個容器可以滾動到底部 */
.container {
  padding-bottom: 150px !important;
  min-height: auto !important; /* 改為自動高度 */
}

/* 確保分頁按鈕可見 */
.pagination-container {
  margin-bottom: 50px !important;
  padding-bottom: 20px !important;
  position: relative !important;
  z-index: 900 !important;
  height: auto !important;
  min-height: auto !important;
  width: 100% !important; /* 確保容器寬度為100% */
}

/* 手機模式下的特殊樣式 */
@media (max-width: 768px) {
  .container, .song-list-container, .openai-container {
    max-height: calc(100vh - 150px) !important; /* 在手機模式下減少高度 */
  }
  
  .container {
    padding-bottom: 200px !important;
  }
  
  /* 確保內容可滾動 */
  body, html, #app, .main-content, .scrollable-content {
    overflow-y: auto !important;
    height: auto !important;
    -webkit-overflow-scrolling: touch !important;
  }
  
  /* 強制啟用滾動 */
  .list-group {
    overflow-y: auto !important;
    max-height: none !important;
  }
  
  /* 確保列表項可見 */
  .list-group-item {
    overflow: visible !important;
    max-height: none !important;
  }
}

/* 超小屏幕的特殊處理 */
@media (max-width: 480px) {
  .container, .song-list-container, .openai-container {
    max-height: calc(100vh - 120px) !important; /* 在超小屏幕上進一步減少高度 */
  }
  
  .container {
    padding-bottom: 250px !important;
  }
  
  .pagination-container {
    margin-bottom: 20px !important;
    padding-bottom: 10px !important;
    width: 100% !important;
  }
}

/* 強制啟用滾動的額外修復 */
.list-group, .list-group-item, .row, .col-md-4, .col-md-6 {
  overflow: visible !important;
  height: auto !important;
}

/* 確保滾動條在需要時顯示 */
.container::-webkit-scrollbar {
  width: 5px !important;
  display: block !important;
}

.container::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.2) !important;
  border-radius: 5px !important;
}

/* 調整滾動容器的高度 - 增加大屏幕下的高度 */
.scrollable-song-container {
  height: calc(100vh - 10px) !important; /* 進一步增加高度，從150px減少到100px */
  overflow-y: auto !important;
  -webkit-overflow-scrolling: touch !important;
  position: relative !important;
  padding-bottom: 100px !important; /* 減少底部間距，從150px減少到100px */
}

/* 修復滾動問題 - 增加大屏幕下的最大高度 */
.container, .song-list-container, .openai-container {
  max-height: calc(100vh - 100px) !important; /* 進一步增加最大高度，從150px減少到100px */
  overflow-y: auto !important; /* 啟用垂直滾動 */
  -webkit-overflow-scrolling: touch !important; /* 增加 iOS 滾動支持 */
  position: relative !important;
}

/* 大屏幕特殊處理 */
@media (max-width: 1200px) {
  .scrollable-song-container {
    height: calc(100vh - 50px) !important; /* 在大屏幕上進一步增加高度 */
    padding-bottom: 10px !important; /* 在大屏幕上減少底部間距 */
  }
  
  .container, .song-list-container, .openai-container {
    max-height: calc(100vh - 80px) !important; /* 在大屏幕上進一步增加最大高度 */
  }
  
  /* 確保列表項在大屏幕上有足夠的高度 */
  .list-group-item {
    min-height: 60px !important; /* 確保列表項有足夠的高度 */
  }
  
  /* 確保視頻預覽區域在大屏幕上有足夠的高度 */
  .video-wrapper1 {
    min-height: 50px !important; /* 確保視頻預覽區域有足夠的高度 */
  }
}

/* 超大屏幕特殊處理 */
@media (max-width: 1600px) {
  .scrollable-song-container {
    height: calc(100vh - 60px) !important; /* 在超大屏幕上進一步增加高度 */
    padding-bottom: 6px !important; /* 在超大屏幕上減少底部間距 */
  }
  
  .container, .song-list-container, .openai-container {
    max-height: calc(100vh - 60px) !important; /* 在超大屏幕上進一步增加最大高度 */
  }
  
  /* 確保列表項在超大屏幕上有足夠的高度 */
  .list-group-item {
    min-height: 80px !important; /* 確保列表項有足夠的高度 */
  }
  
  /* 確保視頻預覽區域在超大屏幕上有足夠的高度 */
  .video-wrapper1 {
    min-height: 80px !important; /* 確保視頻預覽區域有足夠的高度 */
  }
}

/* 調整分頁按鈕的樣式 */
.pagination {
  margin-bottom: 10px !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  flex-wrap: wrap !important;
  width: 100% !important; /* 確保分頁按鈕容器寬度為100% */
  max-width: 100% !important;
}

/* 調整分頁按鈕的大小 */
.pagination .page-item .page-link {
  padding: 0.25rem 0.5rem !important;
  font-size: 0.9rem !important;
  margin: 0 2px !important; /* 減少按鈕之間的間距 */
}

/* 手機模式下的特殊樣式 */
@media (max-width: 768px) {
  .scrollable-song-container {
    height: calc(100vh - 150px) !important; /* 在手機模式下減少高度 */
    padding-bottom: 200px !important;
  }
  
  .container, .song-list-container, .openai-container {
    max-height: calc(100vh - 150px) !important; /* 在手機模式下減少最大高度 */
  }
  
  /* 其他手機模式樣式保持不變 */
  /* ... */
}

/* 超小屏幕的特殊處理 */
@media (max-width: 480px) {
  .scrollable-song-container {
    height: calc(100vh - 120px) !important; /* 在超小屏幕上減少高度 */
    padding-bottom: 250px !important;
  }
  
  .container, .song-list-container, .openai-container {
    max-height: calc(100vh - 120px) !important; /* 在超小屏幕上減少最大高度 */
  }
  
  /* 其他超小屏幕樣式保持不變 */
  /* ... */
}

/* 其他樣式保持不變 */
/* ... */

/* 調整分頁容器的樣式 */
.pagination-container {
  margin-bottom: 50px !important;
  padding-bottom: 20px !important;
  position: relative !important;
  z-index: 900 !important;
  height: auto !important;
  min-height: auto !important;
  width: 100% !important; /* 確保容器寬度為100% */
  display: flex !important; /* 使用 flex 佈局 */
  justify-content: center !important; /* 水平居中 */
  align-items: center !important; /* 垂直居中 */
  flex-direction: column !important; 
}

/* 調整分頁按鈕的樣式 - 完全重寫 */
.pagination {
  margin-bottom: 10px !important;
  display: inline-flex !important; /* 使用 inline-flex 而不是 flex */
  justify-content: center !important;
  align-items: center !important;
  flex-wrap: nowrap !important; /* 禁止換行 */
  width: auto !important; /* 自動寬度 */
  max-width: 100% !important;
  padding: 5px 10px !important; /* 增加內邊距 */
  background-color: rgba(0, 0, 0, 0.3) !important; /* 添加背景色 */
  border-radius: 10px !important; /* 圓角 */
  overflow-x: auto !important; /* 允許水平滾動 */
  -webkit-overflow-scrolling: touch !important; /* 增加 iOS 滾動支持 */
  white-space: nowrap !important; /* 禁止文本換行 */
  transform: scale(0.9) !important; /* 整體縮小 */
  transform-origin: center !important;
}

/* 隱藏分頁按鈕的滾動條 */
.pagination::-webkit-scrollbar {
  display: none !important;
}

/* 調整分頁按鈕的大小 */
.pagination .page-item {
  display: inline-block !important; /* 內聯塊級元素 */
  margin: 0 1px !important; /* 減少按鈕之間的間距 */
  float: none !important; /* 防止浮動 */
}

.pagination .page-item .page-link {
  padding: 0.15rem 0.3rem !important; /* 減小按鈕內邊距 */
  font-size: 0.8rem !important; /* 減小字體大小 */
  white-space: nowrap !important; /* 禁止文本換行 */
  display: inline-block !important; /* 內聯塊級元素 */
}

/* 手機模式下的特殊樣式 */
@media (max-width: 768px) {
  /* 調整分頁容器的樣式 */
  .pagination-container {
    margin-bottom: 30px !important;
    padding-bottom: 15px !important;
  }
  
  /* 調整分頁按鈕的樣式 */
  .pagination {
    width: auto !important; /* 自動寬度 */
    max-width: 95% !important; /* 最大寬度 */
    padding: 5px !important; /* 減少內邊距 */
    transform: scale(0.85) !important; /* 稍微縮小 */
    transform-origin: center !important;
  }
  
  /* 調整分頁按鈕的大小 */
  .pagination .page-item .page-link {
    padding: 0.1rem 0.25rem !important; /* 進一步減小按鈕內邊距 */
    font-size: 0.75rem !important; /* 進一步減小字體大小 */
  }
}

/* 超小屏幕的特殊處理 */
@media (max-width: 480px) {
  /* 調整分頁容器的樣式 */
  .pagination-container {
    margin-bottom: 20px !important;
    padding-bottom: 10px !important;
  }
  
  /* 調整分頁按鈕的樣式 - 超小屏幕特殊處理 */
  .pagination {
    width: auto !important; /* 自動寬度 */
    max-width: 100% !important; /* 最大寬度 */
    padding: 3px !important; /* 減少內邊距 */
    transform: scale(0.75) !important; /* 進一步縮小 */
    transform-origin: center !important;
  }
  
  /* 調整分頁按鈕的大小 - 超小屏幕特殊處理 */
  .pagination .page-item .page-link {
    padding: 0.05rem 0.2rem !important; /* 進一步減小按鈕內邊距 */
    font-size: 0.7rem !important; /* 進一步減小字體大小 */
  }
}

/* 其他樣式保持不變 */
/* ... */

/* 使用唯一的類名來避免衝突 */
.custom-pagination-container {
  margin-bottom: 30px !important;
  padding-bottom: 10px !important;
  position: relative !important;
  z-index: 900 !important;
  width: 100% !important;
  display: flex !important;
  justify-content: flex-end !important; /* 靠右對齊 */
  align-items: center !important;
}

/* 使用唯一的類名來避免衝突 */
.custom-pagination {
  margin-bottom: 10px !important;
  display: inline-flex !important;
  justify-content: center !important;
  align-items: center !important;
  flex-wrap: nowrap !important; /* 禁止換行 */
  width: auto !important;
  max-width: 100% !important;
  padding: 5px 10px !important;
  background-color: rgba(0, 0, 0, 0.3) !important;
  border-radius: 10px !important;
  overflow-x: auto !important;
  -webkit-overflow-scrolling: touch !important;
  white-space: nowrap !important;
  transform: scale(0.9) !important;
  transform-origin: right center !important; /* 從右側縮放 */
}

/* 隱藏分頁按鈕的滾動條 */
.custom-pagination::-webkit-scrollbar {
  display: none !important;
}

/* 調整分頁按鈕的大小 */
.custom-pagination .page-item {
  display: inline-block !important;
  margin: 0 1px !important;
  float: none !important;
}

.custom-pagination .page-item .page-link {
  padding: 0.15rem 0.3rem !important;
  font-size: 0.8rem !important;
  white-space: nowrap !important;
  display: inline-block !important;
}

/* 手機模式下的特殊樣式 */
@media (max-width: 768px) {
  .custom-pagination-container {
    margin-bottom: 20px !important;
    padding-bottom: 10px !important;
  }
  
  .custom-pagination {
    width: auto !important;
    max-width: 95% !important;
    padding: 5px !important;
    transform: scale(0.85) !important;
    transform-origin: right center !important; /* 從右側縮放 */
  }
  
  .custom-pagination .page-item .page-link {
    padding: 0.1rem 0.25rem !important;
    font-size: 0.75rem !important;
  }
}

/* 超小屏幕的特殊處理 */
@media (max-width: 480px) {
  .custom-pagination-container {
    margin-bottom: 15px !important;
    padding-bottom: 5px !important;
  }
  
  .custom-pagination {
    width: auto !important;
    max-width: 100% !important;
    padding: 3px !important;
    transform: scale(0.75) !important;
    transform-origin: right center !important; /* 從右側縮放 */
  }
  
  .custom-pagination .page-item .page-link {
    padding: 0.05rem 0.2rem !important;
    font-size: 0.7rem !important;
  }
  
  .custom-pagination .page-item {
    margin: 0 !important;
  }
}

/* 其他樣式保持不變 */
/* ... */

/* 其他樣式保持不變 */
/* ... */

/* 調整模型選擇框的高度和樣式 */
#model-select-desktop, #model-select-mobile {
  height: 32px !important; /* 減小高度 */
  font-size: 0.85rem !important;
  padding: 0.15rem 0.5rem !important;
  background-color: rgba(255, 255, 255, 0.1) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  color: white !important;
  border-radius: 4px !important;
}

/* 調整選項的樣式 */
#model-select-desktop optgroup,
#model-select-desktop option,
#model-select-mobile optgroup,
#model-select-mobile option {
  font-size: 0.85rem !important;
  background-color: #343a40 !important;
  color: white !important;
}

/* 調整所有按鈕的基本樣式 */
.action-buttons .btn,
.mobile-buttons .btn {
  height: 32px !important; /* 與選擇框高度一致 */
  width: 32px !important; /* 保持正方形 */
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 !important;
  margin-left: 5px !important;
  border: 1px solid rgba(255, 255, 255, 0.5) !important; /* 所有按鈕都添加白色細框 */
}

/* 調整按鈕圖標的大小 */
.action-buttons .btn i,
.mobile-buttons .btn i {
  font-size: 0.85rem !important;
}

/* 附加文件和語音輸出按鈕使用反白樣式 */
.action-buttons .btn-outline-secondary,
.mobile-buttons .btn-outline-secondary {
  background-color: rgba(255, 255, 255, 0.8) !important; /* 反白背景 */
  color: #343a40 !important; /* 深色文字 */
  border-color: rgba(255, 255, 255, 0.9) !important; /* 白色邊框 */
}

/* 附加文件和語音輸出按鈕的懸停效果 */
.action-buttons .btn-outline-secondary:hover,
.mobile-buttons .btn-outline-secondary:hover {
  background-color: rgba(0, 0, 0, 0.7) !important; /* 懸停時變黑 */
  color: white !important; /* 懸停時文字變白 */
  border-color: rgba(255, 255, 255, 0.9) !important; /* 保持白色邊框 */
}

/* 發送按鈕樣式 */
.action-buttons .btn-primary,
.mobile-buttons .btn-primary {
  background-color: #007bff !important; /* 藍色背景 */
  color: white !important; /* 白色文字 */
  border: 1px solid rgba(255, 255, 255, 0.9) !important; /* 白色邊框 */
}

/* 發送按鈕懸停效果 */
.action-buttons .btn-primary:hover,
.mobile-buttons .btn-primary:hover {
  background-color: #0069d9 !important; /* 深藍色背景 */
  border-color: white !important; /* 純白色邊框 */
}

/* 語音播放激活狀態 */
.action-buttons .voice-active,
.mobile-buttons .voice-active {
  background-color: #007bff !important; /* 藍色背景 */
  color: white !important; /* 白色文字 */
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.5) !important; /* 內陰影效果 */
}

/* 其他樣式保持不變 */
/* ... */

/* 添加載入更多提示的樣式 */
.loading-more {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  background-color: rgba(0, 0, 0, 0.3);
  margin-top: 1rem;
  border-radius: 8px;
}

/* 確保在手機模式下容器可以平滑滾動 */
@media (max-width: 768px) {
  .scrollable-song-container {
    height: calc(100vh - 150px);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    position: relative;
  }

  .list-group {
    padding-bottom: 60px;
  }

  .loading-more {
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1000;
    width: 90%;
    max-width: 300px;
    background-color: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(5px);
    border: 1px solid rgba(255, 255, 255, 0.1);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
}

/* 修改容器樣式 */
.scrollable-song-container {
  height: calc(100vh - 60px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  position: relative;
}

/* 手機模式特殊樣式 */
.mobile-container {
  height: calc(100vh - 120px) !important;
  padding-bottom: 80px !important;
}

/* 修改載入提示樣式 */
.loading-more-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 8px 16px;
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 20px;
  backdrop-filter: blur(5px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  width: auto;
  max-width: 200px;
  margin: 0 auto;
  animation: fadeInOut 1s ease-in-out infinite;
}

@keyframes fadeInOut {
   0% { opacity: 0.7; }
   50% { opacity: 1; }
   100% { opacity: 0.7; }
}

.load-more-text {
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.85rem;
  text-align: center;
  padding: 8px 0;
  animation: fadeInOut 1.5s ease-in-out infinite;
}

/* 手機模式下的特殊處理 */
@media (max-width: 768px) {
  .scrollable-song-container {
    height: calc(100vh - 120px);
    padding-bottom: 80px;
  }

  .load-more-area {
    position: relative;
    margin-top: 10px;
    padding: 10px 0;
  }

  .loading-more-indicator {
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1000;
  }
}

/* 載入觸發器樣式 */
.load-more-trigger {
  min-height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  margin-bottom: 60px; /* 增加底部間距 */
}

/* 載入更多區域樣式 */
.load-more-area {
  width: 100%;
  padding: 20px 0;
  margin-top: 20px;
  text-align: center;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.1));
}

/* 載入觸發器樣式 */
.load-more-trigger {
  min-height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
}

/* 載入提示樣式 */
.loading-more-indicator {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 16px;
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 20px;
  backdrop-filter: blur(5px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.spinner-small {
  width: 1rem;
  height: 1rem;
}

.loading-text, .load-more-text {
  color: white;
  font-size: 0.9rem;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}

/* 手機模式下的特殊處理 */
@media (max-width: 768px) {
  .scrollable-song-container {
    height: calc(100vh - 120px);
    padding-bottom: 100px; /* 增加底部間距 */
  }

  .list-group {
    margin-bottom: 0;
  }

  .load-more-area {
    position: relative;
    margin-top: 10px;
    padding-bottom: 80px; /* 增加底部間距 */
  }

  .loading-more-indicator {
    position: static;
    transform: none;
    margin: 0 auto;
    width: auto;
    max-width: 80%;
  }
}

/* 確保列表和載入區域的可見性 */
.list-group, .load-more-area {
  position: relative;
  z-index: 1;
}

/* 修改載入提示樣式 */
.load-more-area {
  width: 100%;
  padding: 10px 0;
  margin-top: 10px;
  text-align: center;
}

.loading-more-indicator {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 8px 16px;
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 20px;
  backdrop-filter: blur(5px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.load-more-text {
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.85rem;
  padding: 8px 16px;
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 20px;
}

/* 簡化並優化載入提示樣式 */
.load-more-area {
  width: 100%;
  padding: 20px 0;
  text-align: center;
  position: relative;
  margin-top: 20px;
}

.loading-more-indicator,
.load-more-text {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 8px 16px;
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 20px;
  color: white;
  font-size: 0.9rem;
}

/* 手機模式下的特殊處理 */
@media (max-width: 768px) {
  .scrollable-song-container {
    height: calc(100vh - 120px);
    padding-bottom: 100px;
  }

  .load-more-area {
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1000;
    width: auto;
    margin: 0;
    padding: 0;
  }
}

.load-more-text {
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.85rem;
  padding: 8px 16px;
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 20px;
  cursor: pointer; /* 添加指針樣式 */
  transition: all 0.3s ease; /* 添加過渡效果 */
}

.load-more-text:not(.disabled):hover {
  background-color: rgba(0, 0, 0, 0.9);
  transform: scale(1.05);
}

.load-more-text.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* 手機模式下的特殊處理 */
@media (max-width: 768px) {
  .load-more-area {
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1000;
    width: auto;
    margin: 0;
    padding: 0;
  }

  .load-more-text {
    white-space: nowrap;
    min-width: 120px;
    text-align: center;
  }
}

/* 修改載入提示樣式 */
.load-more-area {
  width: 100%;
  padding: 10px 20px;
  text-align: right; /* 改為靠右對齊 */
  position: relative;
}

.loading-more-indicator,
.load-more-text {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 6px 12px; /* 縮小內邊距 */
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 15px; /* 稍微縮小圓角 */
  color: white;
  font-size: 0.8rem; /* 縮小字體 */
  min-width: 80px; /* 設置最小寬度 */
  text-align: center; /* 確保文字居中 */
}

/* 手機模式下的特殊處理 */
@media (max-width: 768px) {
  .load-more-area {
    position: fixed;
    bottom: 20px;
    right: 20px; /* 改為靠右固定位置 */
    left: auto;
    transform: none;
    z-index: 1000;
    width: auto;
    margin: 0;
    padding: 0;
  }

  .load-more-text {
    white-space: nowrap;
    min-width: 80px; /* 縮小最小寬度 */
    text-align: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); /* 添加陰影 */
  }

  /* 優化載入中狀態的樣式 */
  .loading-more-indicator {
    min-width: 80px;
    justify-content: center;
  }

  /* 優化 spinner 大小 */
  .spinner-small {
    width: 0.8rem;
    height: 0.8rem;
  }
}

/* 優化按鈕懸停效果 */
.load-more-text:not(.disabled):hover {
  background-color: rgba(0, 0, 0, 0.9);
  transform: scale(1.02); /* 縮小放大效果 */
}

/* YouTube 搜索結果特定樣式 */
.youtube-video-wrapper {
  padding-bottom: 0 !important; /* 移除固定寬高比，讓高度根據內容自動調整 */
  padding-top: 0 !important; /* 減少向上 padding */
  height: auto !important;
  min-height: auto !important;
  margin-bottom: 0 !important; /* 減少向下 margin */
}

.youtube-thumbnail-fallback {
  align-items: flex-start !important;
  justify-content: center !important;
  position: relative !important;
  height: auto !important;
  min-height: auto !important;
  padding: 0 !important; /* 移除所有 padding */
}

.youtube-thumbnail {
  width: 100% !important;
  height: auto !important;
  max-height: 200px !important; /* 限制最大高度，避免過高 */
  object-fit: cover !important;
  object-position: center top !important;
  border-radius: 8px;
  display: block !important;
  margin: 0 !important; /* 移除 margin */
  padding: 0 !important; /* 移除 padding */
}

/* 確保 YouTube 搜索結果的列表項高度正常 */
.youtube-results-container .list-group-item {
  min-height: auto !important;
  height: auto !important;
  padding-top: 0.25rem !important; /* 減少向上 padding */
  padding-bottom: 0.25rem !important; /* 減少向下 padding */
}

.youtube-results-container .row {
  min-height: auto !important;
  height: auto !important;
  align-items: flex-start !important;
}

.youtube-results-container .col-md-4 {
  height: auto !important;
  min-height: auto !important;
}

.youtube-results-container .col-md-6 {
  height: auto !important;
  min-height: auto !important;
}

/* 手機端 YouTube 搜索結果樣式 */
@media (max-width: 768px) {
  .youtube-results-container .video-wrapper1 {
    width: 100% !important;
    padding-bottom: 0 !important;
    padding-top: 0 !important;
    margin-bottom: 0 !important;
    height: auto !important;
    min-height: auto !important;
  }
  
  .youtube-results-container .youtube-thumbnail-fallback {
    position: relative !important;
    height: auto !important;
    min-height: auto !important;
    padding: 0 !important;
    display: block !important;
  }
  
  .youtube-results-container .youtube-thumbnail {
    width: 100% !important;
    height: auto !important;
    max-height: 150px !important; /* 手機端稍微小一點 */
    object-fit: cover !important;
    object-position: center top !important;
    display: block !important;
    margin: 0 !important;
    padding: 0 !important;
  }
  
  .youtube-results-container .col-md-4 {
    flex: 0 0 100% !important;
    max-width: 100% !important;
    height: auto !important;
    min-height: auto !important;
  }
  
  .youtube-results-container .col-md-6 {
    flex: 0 0 100% !important;
    max-width: 100% !important;
    height: auto !important;
    min-height: auto !important;
  }
  
  .youtube-results-container .list-group-item {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
}
</style>
